import { render, staticRenderFns } from "./ResearchRequestModal.vue?vue&type=template&id=1c5955fa&scoped=true&"
import script from "./ResearchRequestModal.vue?vue&type=script&lang=js&"
export * from "./ResearchRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./ResearchRequestModal.vue?vue&type=style&index=0&id=1c5955fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5955fa",
  null
  
)

export default component.exports